/**
 * AccountsPage Messages
 *
 * This contains all the text for the AccountsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.admin.accounts';

export default defineMessages({
  newAccount: {
    id: `${scope}.newAccount`,
    defaultMessage: 'New Account',
  },
  admin: {
    id: `${scope}.admin`,
    defaultMessage: 'Admin',
  },
  create: {
    id: `${scope}.create`,
    defaultMessage: 'create',
  },
  accounts: {
    id: `${scope}.accounts`,
    defaultMessage: 'Accounts',
  },
  account: {
    id: `${scope}.account`,
    defaultMessage: 'account',
  },
});
